/**
 * Projects total spending over a full period based on the daily average so far.
 * Formula: (totalSpent / daysElapsed) * totalDays
 *
 * @param totalSpent   - Amount spent so far in the period
 * @param daysElapsed  - Number of days elapsed in the period (must be > 0)
 * @param totalDays    - Total days in the period
 */
export function computeTrendProjection(
  totalSpent: number,
  daysElapsed: number,
  totalDays: number
): number {
  return (totalSpent / daysElapsed) * totalDays;
}
